
import { gql } from '@apollo/client';

export const GET_COMPANY_QUERY = gql`
query company {
    company {
      id
      name
      status
      contactEmailAddress
      defaultLocaleCode
      variableList {
        name
        value
      }
    }
  }`;